import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0',
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  },
  customSpinner: {
    animation: 'spin 1s linear infinite',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #40B9C3',
    borderRadius: '50%',
  },
  materialSpinner: {
    color: '#40B9C3',
  },
  text: {
    color: '#666',
    fontSize: '0.9rem',
    marginTop: theme.spacing(1),
  },
  small: {
    width: 20,
    height: 20,
    borderWidth: '2px',
  },
  medium: {
    width: 40,
    height: 40,
    borderWidth: '4px',
  },
  large: {
    width: 60,
    height: 60,
    borderWidth: '6px',
  },
}))

export default function CircularIndeterminate({ 
  size = 'medium', 
  message = '', 
  variant = 'custom',
  color = '#40B9C3'
}) {
  const classes = useStyles()

  const getSizeClass = () => {
    switch (size) {
      case 'small': return classes.small
      case 'large': return classes.large
      default: return classes.medium
    }
  }

  const spinnerStyle = variant === 'custom' 
    ? { ...classes.customSpinner, ...getSizeClass(), borderTopColor: color }
    : classes.materialSpinner

  const spinnerSize = variant === 'material' ? size : undefined

  return (
    <div className={classes.root}>
      {variant === 'custom' ? (
        <div className={spinnerStyle} />
      ) : (
        <CircularProgress 
          size={spinnerSize} 
          className={spinnerStyle}
          style={{ color }}
        />
      )}
      {message && (
        <Typography variant="body2" className={classes.text}>
          {message}
        </Typography>
      )}
    </div>
  )
}
